import { ref } from 'vue'

export const useRequestList = (options = {}) => {
  let pageNo = 1
  const finished = ref(false)
  const loading = ref(false)
  let isRequest = false
  const reset = () => {
    pageNo = 1
    finished.value = false
  }
  const request = async req => {
    try {
      if (finished.value || isRequest) {
        return
      }
      isRequest = true
      const res = await req(pageNo)
      finished.value = options.finished && options.finished(res, pageNo)
      if (options.pageIncrease && options.pageIncrease(res)) {
        pageNo++
      }
      return res
    } catch (error) {
      return Promise.reject(error)
    } finally {
      loading.value = false
      isRequest = false
    }
  }
  return {
    reset,
    request,
    finished,
    loading,
  }
}
